// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__oPcIK","canvas":"style_canvas__pR6JS","button":"style_button__QRfss"};